module.exports = __webpack_public_path__ + "img/Gastos Comunes.b17804ec.svg";